document.addEventListener('DOMContentLoaded', function(e) {
  allContainer = document.querySelectorAll("div[ex-popup-container]");
  document.querySelectorAll("*[ex-popup-open]").forEach((elem) => {
    let container = elem.getAttribute('ex-popup-open');
    elem.addEventListener('click', function() {

      allContainer.forEach((element) => {
        element.classList.remove('tw-flex');
        element.classList.add('tw-hidden');
      });

      document.querySelector("div[ex-popup-container='" + container + "']").classList.remove('tw-hidden');
      document.querySelector("div[ex-popup-container='" + container + "']").classList.add('tw-flex');
    });
  });

  document.querySelectorAll("*[ex-popup-close]").forEach((elem) => {
    let container = elem.getAttribute('ex-popup-close');
    elem.addEventListener('click', function() {

      allContainer.forEach((element) => {
        element.classList.remove('tw-flex');
        element.classList.add('tw-hidden');
      });

      document.querySelector("div[ex-popup-container='" + container + "']").classList.add('tw-hidden');
      document.querySelector("div[ex-popup-container='" + container + "']").classList.remove('tw-flex');
    });
  });
})